import Type from "@/model/types/Type";

const type = {
    DEFAULT: 1,
    CATEGORY: 2,
}

const list = [
    {
        value: type.DEFAULT,
        text: "Padrão",
    },
    {
        value: type.CATEGORY,
        text: "Categoria",
    },

]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}